import React from 'react';
import { facilityAddress } from './waitingGateways';

const WaitingGatewayRow = ({ device, serial, facilities }) => {
    const address = facilityAddress(facilities, device.facility_id);
    return (
        <li className="gateway-section__waiting-item" data-testid="waiting-gateway">
            <span className="gateway-section__waiting-badge">
                <i className="fa-regular fa-clock"></i>
                <span>Waiting</span>
            </span>
            <span className="gateway-section__waiting-name">
                {serial ? (
                    <strong className="gateway-section__waiting-serial">{serial.toUpperCase()}</strong>
                ) : (
                    device.custom_device_name || device.name || device.id
                )}
                {address && <span className="gateway-section__waiting-address"> · {address}</span>}
            </span>
        </li>
    );
};

export default WaitingGatewayRow;
